export default "/images/031f0b8ca0f5668924aaf70c499abd7d.avif";